export enum EPaymentStatus {
  New = 'new',
  Pending = 'pending',
  Paid = 'paid',
  Expired = 'expired',
  Error = 'error',
}
